<template>
  <div>
    <div class="mb-8 flex justify-start max-w-full flex-wrap">
      <h1 class="font-bold text-3xl">
        <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('users')">
          Users
        </inertia-link>
        <span class="text-indigo-400 font-medium">/</span>
        {{ form.first_name }} {{ form.last_name }}
      </h1>
      <h1>
        <span :class="isEmailVerified" class="text-3xl md:ml-2 mt-2 md:mt-0">{{ emailVerifiedAt }}</span>
      </h1>
    </div>
    <trashed-message
      v-if="user.deleted_at"
      class="mb-6"
      @restore="restore">
      This user has been deleted.
    </trashed-message>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input
            v-model="form.first_name"
            :error="form.errors.first_name"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Nama Depan" />
          <text-input
            v-model="form.last_name"
            :error="form.errors.last_name"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Nama Belakang" />
          <text-input
            v-model="form.email"
            :error="form.errors.email"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Email" />
          <text-input
            v-model="form.bank_acc_number"
            :error="form.errors.bank_acc_number"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Nomor Rekening Bank" />
          <select-input
            v-model="form.roles"
            :error="form.errors.roles"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Role">
            <option value="mahasiswa">
              Mahasiswa
            </option>
            <option value="admin">
              Admin
            </option>
            <option value="guest" disabled>
              Guest
            </option>
          </select-input>
          <text-input
            v-model="form.password"
            :error="form.errors.password"
            class="pr-6 pb-8 w-full lg:w-1/2"
            type="password"
            autocomplete="new-password"
            label="Password" />
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex flex-wrap">
          <button
            v-if="!user.deleted_at"
            class="text-red-600 hover:underline flex-no-wrap"
            tabindex="-1"
            type="button"
            @click="destroy">
            Delete User
          </button>
          <template v-if="user.verified">
            <loading-button
              :loading="form.processing"
              class="btn-indigo ml-auto"
              type="submit">
              Update
              User
            </loading-button>
          </template>
          <template v-else>
            <button
              class="btn-red ml-auto"
              type="button"
              @click="verifyUser">
              Verify Email
            </button>
            <loading-button
              :loading="form.processing"
              class="btn-indigo md:ml-2 ml-auto px-2 mt-2 md:mt-0"
              type="submit">
              Update User
            </loading-button>
          </template>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import { useForm, Link } from '@inertiajs/vue2'

export default {
    metaInfo () {
        return {
            title: `${this.form.first_name} ${this.form.last_name}`,
        }
    },
    components: {
        LoadingButton,
        SelectInput,
        TextInput,
        TrashedMessage,
        'inertia-link': Link,
    },
    layout: Layout,
    props: {
        user: Object,
    },
    remember: 'form',
    data () {
        return {
            form: useForm({
                first_name: this.user.first_name,
                last_name: this.user.last_name,
                email: this.user.email,
                password: null,
                roles: this.user.roles,
                bank_acc_number: this.user.bank_acc_number,
            }),
            formVerify: useForm({
                verified: this.user.verified,
            }),
        }
    },
    computed: {
        isEmailVerified () {
            return this.user.verified
                ? 'fas fa-check-circle text-green-600'
                : 'fas fa-times-circle text-red-600'
        },
        emailVerifiedAt () {
            return this.user.verified
                ? ` (${this.user.email_verified_at})`
                : ''
        },
    },
    methods: {
        update () {
            this.form.put(this.route('users.update', this.user.id), {
                onSuccess: () => this.form.reset('password'),
            })
        },
        destroy () {
            if (confirm('Are you sure you want to delete this user?')) {
                this.form.delete(this.route('users.destroy', this.user.id))
            }
        },
        restore () {
            if (confirm('Are you sure you want to restore this user?')) {
                this.form.put(this.route('users.restore', this.user.id))
            }
        },
        verifyUser () {
            this.formVerify.patch(this.route('users.verify', this.user.id), {
                onSuccess: () => this.form.reset('password'),
            })
        },
    },
}
</script>
